import React, { useState } from 'react'
import styled from 'styled-components'

import { Button, Collapsible, FormOnChange, Stack, Textarea } from '@procsea/design-system'

const StyledButton = styled(Button)`
  margin-top: -0.7rem;
  margin-left: -0.7rem;
`

const StyledTextarea = styled(Textarea)`
  margin-bottom: 0.7rem;
`

export interface ExpandTextareaProps {
  'data-e2e'?: string
  buttonLabel: string
  disabled?: boolean
  errorMessage?: string
  fluid?: boolean
  maxLength?: number
  minLength?: number
  name?: string
  onChange?: FormOnChange<string>
  placeholder?: string
  rows?: number
  value?: string
  warningMessage?: string
}

const ExpandTextarea = ({
  'data-e2e': dataE2e = 'expand-textarea-field',
  buttonLabel,
  disabled,
  errorMessage,
  fluid,
  maxLength,
  minLength,
  name,
  onChange,
  placeholder,
  rows = 2,
  value,
  warningMessage,
}: ExpandTextareaProps) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Stack data-e2e={dataE2e} alignment="flex-start" fullWidth={fluid}>
      <StyledButton
        data-e2e="expand-textarea-button"
        icon={expanded ? 'chevron-up' : 'chevron-down'}
        onClick={() => setExpanded(prev => !prev)}
        reversed
        text
        underline
        variant="primary"
      >
        {`${buttonLabel} (${!!value ? 1 : 0}/1)`}
      </StyledButton>

      <Collapsible
        data-e2e="expand-content"
        fluid={fluid}
        open={expanded}
        duration={100}
        setOpen={setExpanded}
      >
        <StyledTextarea
          data-e2e={'expand-textarea'}
          disabled={disabled}
          errorMessage={errorMessage}
          fluid={fluid}
          maxLength={maxLength}
          minLength={minLength}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          value={value}
          warningMessage={warningMessage}
        />
      </Collapsible>
    </Stack>
  )
}

export default ExpandTextarea
